import React, { Component } from 'react';
import { Input, Form, Select, Checkbox, Modal, Row, Col, Button, message } from 'antd';
import config from '$config';
import { withRouter } from 'react-router-dom';
import { Segment } from '@fxtr/i18n';
import { Hr, TextAreaGrey, ContainerStyled } from './styled';

const categories = [
  'Adjustment',
  'Ancillaries',
  'Automatic Transmission',
  'Battery',
  'Belts',
  'Body',
  'Brakes',
  'Car Wash',
  'Clutch & Transmission',
  'Cooling System',
  'Coupon',
  'Credit',
  'Custom Request',
  'Diagnostic',
  'Discount',
  'Driver Fee',
  'Driveshafts, Propshaft & Differential',
  'Engine',
  'Exhaust System',
  'Fixter C&D',
  'Fluids',
  'Free Checks',
  'Fuel System',
  'Full Service',
  'Garage-C&D',
  'General Electrics',
  'Heating & AC',
  'Ignition',
  'Interim Service',
  'Lights & Bulbs',
  'Major Service',
  'MOT',
  'Non-Good',
  'Oil & Oil Filter Change',
  'Paid Checks',
  'Steering',
  'Suspension',
  'Turbocharger & Intercooler',
  'Tyres And Wheel',
  'Vehicle Security',
  'Wheel Bearings',
  'Wing Mirrors',
  'Wiper System',
];
class ProductEditForm extends Component {
  constructor(props) {
    super(props);
    const { operation } = props;
    this.state = {
      customerLabelSameMech: operation ? operation.label_mechanic == operation.label_customer : true,
      previewHTML: null,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { catalogs } = values;
        const product = Object.assign(this.props.operation || {}, values);

        if (this.state.customerLabelSameMech) {
          product.label_customer = product.label_mechanic;
        }

        this.props.onSave({ product, catalogs });
      } else {
        message.error(err);
      }
    });
  };

  render() {
    const { operation, catalogs, isNew, form } = this.props;
    const { getFieldDecorator, getFieldValue } = form;
    const { customerLabelSameMech, previewHTML } = this.state;

    const showSegment =
      config.env !== 'production' ||
      document.cookie.split(';').some((cookie) => cookie.trim().startsWith('motrioCheckoutAccess='));

    return (
      <ContainerStyled className={isNew ? 'new-work-operation' : ''}>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <h2>Label Name</h2>
              <Hr />
              <Form.Item label="Segment" name="segment" hasFeedback>
                {getFieldDecorator('segment', {
                  rules: [
                    {
                      required: true,
                    },
                  ],
                })(
                  <Select placeholder="Select a segment" disabled={!isNew}>
                    <Select.Option value={Segment.Fixter_UK}>United Kingdom 🇬🇧</Select.Option>
                    <Select.Option value={Segment.Fixter_FR}>France 🇫🇷</Select.Option>
                    {showSegment && <Select.Option value={Segment.Motrio_UK}>Motrio UK 🇬🇧</Select.Option>}
                    {showSegment && <Select.Option value={Segment.Motrio_FR}>Motrio France 🇫🇷</Select.Option>}
                    {showSegment && <Select.Option value={Segment.Motrio_IT}>Motrio Italy 🇮🇹</Select.Option>}
                    {showSegment && <Select.Option value={Segment.Motrio_ES}>Motrio Spain 🇪🇸</Select.Option>}
                    {showSegment && <Select.Option value={Segment.Motrio_PT}>Motrio Portugal 🇵🇹</Select.Option>}
                    {showSegment && <Select.Option value={Segment.Motrio_RO}>Motrio Romania 🇷🇴</Select.Option>}
                    {showSegment && <Select.Option value={Segment.Motrio_PL}>Motrio Poland 🇵🇱</Select.Option>}
                    {showSegment && <Select.Option value={Segment.Renault_MA}>Renault Morocco 🇲🇦</Select.Option>}
                  </Select>
                )}
              </Form.Item>

              {!isNew ? (
                <>
                  <p>
                    <b>ID</b>
                    <br />
                    {operation.product_number}
                  </p>
                  <p>
                    <b>Sku</b>
                    <br />
                    {operation.sku}
                  </p>
                </>
              ) : (
                <Form.Item label="Product SKU">
                  {getFieldDecorator('sku', {
                    rules: [{ required: true }],
                  })(<Input placeholder="e.g 'air-conditioning-regas'" />)}
                </Form.Item>
              )}

              <Form.Item label="Default Label Name (on Maia and Gary)">
                {getFieldDecorator('label_mechanic', {
                  rules: [{ required: true }],
                })(<Input placeholder="e.g Air Condition Regas" />)}
              </Form.Item>

              <Form.Item label="Customer Label Name (on Fixter website, online quote and invoice)">
                <Checkbox
                  defaultChecked={customerLabelSameMech}
                  onChange={(e) => this.setState({ customerLabelSameMech: e.target.checked })}
                >
                  Same as default label name
                </Checkbox>
                {!customerLabelSameMech ? (
                  getFieldDecorator('label_customer', {
                    rules: [{ required: true }],
                  })(<Input placeholder="Label Name" />)
                ) : (
                  <Input disabled value={operation.label_mechanic} />
                )}
              </Form.Item>

              <Form.Item label="Category Name" hasFeedback>
                {getFieldDecorator('categories', {
                  rules: [{ required: true }],
                })(
                  <Select placeholder="Select a option and change input text above">
                    {categories.map((c) => (
                      <Select.Option key={c} value={c}>
                        {c}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="Search Terms" hasFeedback>
                {getFieldDecorator('search_terms')(<Input.TextArea rows={4} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <h2>Display Setting</h2>
              <Hr />
              <Form.Item label="Where this product should be displayed">
                {!isNew &&
                  getFieldDecorator('catalogs', {
                    rules: [{ required: !isNew }],
                  })(
                    <Checkbox.Group>
                      <Row style={{ maxHeight: 220, overflow: 'auto' }}>
                        {(catalogs || []).map((catalog) => (
                          <Col span={12} key={catalog.catalogId}>
                            <Checkbox
                              value={catalog.catalogId}
                              // This is associated automatically when
                              // the product is created.
                              disabled={catalog.catalogSlug === 'maia'}
                            >
                              {catalog.catalogName}
                            </Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </Checkbox.Group>
                  )}
                {isNew && <p>Please save your new product and then add it to a catalog.</p>}
              </Form.Item>

              <Form.Item label="Short description" hasFeedback>
                {getFieldDecorator('short_description')(<TextAreaGrey rows={6} />)}
                <Button
                  style={{ float: 'right', background: '#0DB78E', color: 'white' }}
                  onClick={() => this.setState({ previewHTML: getFieldValue('short_description') })}
                >
                  Preview
                </Button>
              </Form.Item>

              <Form.Item label="Full description" hasFeedback>
                {getFieldDecorator('long_description')(<TextAreaGrey rows={6} />)}
                <Button
                  style={{ float: 'right', background: '#0DB78E', color: 'white' }}
                  onClick={() => this.setState({ previewHTML: getFieldValue('long_description') })}
                >
                  Preview
                </Button>
              </Form.Item>
            </Col>
          </Row>

          <Row type="flex" justify="space-between">
            {/* Don't delete products. Soft delete only */}
            {/* <Col>
              {!isNew && (
                <Popconfirm
                  placement="topLeft"
                  okText="Yes"
                  cancelText="No"
                  title="Are you sure you want to remove this product from the list?"
                  onConfirm={() => onDelete(operation.sku)}
                >
                  <p style={{ cursor: 'pointer', color: 'red' }}>Delete Product</p>
                </Popconfirm>
              )}
            </Col> */}
            <Col />

            <Col>
              <Button onClick={() => this.props.history.replace('/')} type="secondary">
                Cancel
              </Button>
              &nbsp;
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Col>
          </Row>

          <Modal
            title="Preview"
            visible={previewHTML}
            footer={[
              <Button key="submit" type="primary" onClick={() => this.setState({ previewHTML: null })}>
                Ok
              </Button>,
            ]}
            onCancel={() => this.setState({ previewHTML: null })}
          >
            <div dangerouslySetInnerHTML={{ __html: previewHTML }} />
          </Modal>
        </Form>
      </ContainerStyled>
    );
  }
}

const mapPropsToFields = (props) => {
  const { operation } = props;

  if (!operation) return;

  const operationFields = {
    ...operation,
    catalogs: props.operationCatalogs,
  };

  return Object.keys(operationFields).reduce((ac, val) => {
    ac[val] = Form.createFormField({
      value: operationFields[val],
    });
    return ac;
  }, {});
};

export default Form.create({
  name: 'productEdit',
  mapPropsToFields,
})(withRouter(ProductEditForm));
